<template>
  <el-skeleton :loading="loading" animated v-if="loading">
    <template slot="template">
      <div
        v-for="(item, index) in schema"
        :key="index"
        :style="{ width: item.width }"
        class="skeleton-row"
      >
        <span v-if="item.icon" class="material-icons">circle</span>
        <el-skeleton-item
          :variant="item.variant || 'h1'"
          class="skeleton-item"
        />
      </div>
    </template>
  </el-skeleton>
</template>

<script>
  /**
   * SkeletonGenerator component
   *
   * A reusable component that displays a skeleton loader when data is being fetched or loaded.
   * The skeleton layout is customizable based on the schema provided through props.
   *
   * @component
   * @example
   * <SkeletonGenerator :loading="true" :schema="[{ width: '100%', icon: true, variant: 'h1' }]"/>
   */
  export default {
    name: 'SkeletonGenerator',
    props: {
      /**
       * Indicates whether the skeleton loader should be displayed.
       *
       * @type {Boolean}
       * @default true
       */
      loading: {
        type: Boolean,
        default: true,
      },
      /**
       * Schema for the skeleton rows. Each item in the schema defines the width,
       * whether an icon should be displayed, and the variant of the skeleton item.
       *
       * @type {Array<{ width: string, icon: boolean, variant?: string }>}
       * @required
       * @validator {Function} Validates that each item in the schema has a valid format.
       */
      schema: {
        type: Array,
        required: true,
        validator: (value) =>
          value.every(
            (item) =>
              typeof item.width === 'string' &&
              typeof item.icon === 'boolean' &&
              (!item.variant || typeof item.variant === 'string')
          ),
      },
    },
  };
</script>

<style scoped>
.skeleton-row {
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  .material-icons {
    margin-right: 10px;
    color: #6e697f;
  }
  .skeleton-item {
    opacity: 0.3;
  }
}
</style>
